export const messages = {
  en: {
    chooseMenuGroup: {
      title: 'Select Menu Group',
      searchPlaceholder: 'Enter menu group name',
      groupId: 'Group ID',
      groupName: 'Group Name',
      icon: 'Icon',
      label: 'Label',
      storeType: 'Store Type',
      seq: 'Sequence',
      description: 'Description',
      operationTeam: 'Operation Team',
      agent: 'Agent',
      logistics: 'Logistics Company',
      merchant: 'Merchant',
      devTeam: 'Development Team',
      runner: 'Runner',
      unknown: 'Unknown'
    }
  },
  zh: {
    chooseMenuGroup: {
      title: '选择菜单组',
      searchPlaceholder: '输入菜单组名称',
      groupId: '组ID',
      groupName: '组名称',
      icon: '图标',
      label: '标签',
      storeType: '归属商户',
      seq: '序列',
      description: '描述',
      operationTeam: '运营团队',
      agent: '代理商',
      logistics: '物流公司',
      merchant: '商家',
      devTeam: '开发团队',
      runner: '跑腿',
      unknown: '未知'
    }
  }
}